/**
 * Re-apply luxury privacy CSS after Shopify injects its default banner styles
 * (Shopify appends <style class="shopify-pc__banner__styles"> late, which would
 * otherwise leave the blue/grey default visible).
 */
(function () {
  var STYLE_ID = 'charmenova-luxury-privacy-banner';
  var HREF = null;

  function findThemeHref() {
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].href && links[i].href.indexOf('component-luxury-privacy-banner') !== -1) {
        return links[i].href;
      }
    }
    return null;
  }

  function ensureStyleLast() {
    if (!HREF) HREF = findThemeHref();
    if (!HREF) return;

    var existing = document.getElementById(STYLE_ID);
    if (existing) {
      if (existing.parentNode === document.body || existing.parentNode === document.documentElement) {
        document.body.appendChild(existing);
      }
      return;
    }

    var link = document.createElement('link');
    link.id = STYLE_ID;
    link.rel = 'stylesheet';
    link.href = HREF;
    document.body.appendChild(link);
  }

  function boot() {
    ensureStyleLast();

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          var id = node.id || '';
          var cls = typeof node.className === 'string' ? node.className : '';
          if (
            id.indexOf('shopify-pc') !== -1 ||
            cls.indexOf('shopify-pc') !== -1 ||
            (node.tagName === 'STYLE' && cls.indexOf('shopify-pc') !== -1)
          ) {
            ensureStyleLast();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Banner can appear slightly after first paint
    window.setTimeout(ensureStyleLast, 500);
    window.setTimeout(ensureStyleLast, 1500);
    window.setTimeout(ensureStyleLast, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
